module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Jc.b890f007.png";